import React, { useContext } from "react"
import { useSelector } from "react-redux"
import { prosodies } from "keys"
import { useCallback } from "react"
import { actions } from "store"
import { useDispatch } from "react-redux"
import { MarkingWordsContext } from "../MarkingWordsContext"

const useHeaderActions = () => {
    const dispatch = useDispatch()
    const { assessmentComments } = useContext(MarkingWordsContext)

    const { isCloseSttoper } = useSelector(state => state.markingWords)
    const { assessment } = useSelector(state => state.assessment)

    const updateProsody = useCallback((val) => {
        dispatch(actions.setAssessment({ ...assessment, prosody: val }))
    }, [assessment])

    const updateComments = useCallback((val) => {
        dispatch(actions.setAssessment({ ...assessment, comments: val }))
    }, [assessment])

    const headerActions = React.useMemo(
        () =>
            [
                {
                    id: 1,
                    name: "prosody",
                    placeholder: "פרוזודיה",
                    width: 220,
                    options: prosodies,
                    component: 'autoComplete',
                    input: {
                        value: assessment.prosody,
                        onChange: updateProsody
                    },
                    disabled: isCloseSttoper
                },
                {
                    id: 2,
                    name: "comments",
                    placeholder: "הוסף הערה למבדק",
                    width: 350,
                    options: assessmentComments.data,
                    component: 'autoComplete',
                    labelKey: "content",
                    tooltipKey: "content",
                    multiple: true,
                    input: {
                        value: assessment.comments,
                        onChange: updateComments
                    },
                    disabled: isCloseSttoper
                }
            ],
        [assessment, isCloseSttoper]
    );

    return headerActions
}

export default useHeaderActions